/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SetShoppingCartBookModel model module.
 * @module model/SetShoppingCartBookModel
 * @version v1.0.0
 */
class SetShoppingCartBookModel {
    /**
     * Constructs a new <code>SetShoppingCartBookModel</code>.
     * @alias module:model/SetShoppingCartBookModel
     */
    constructor() { 
        
        SetShoppingCartBookModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SetShoppingCartBookModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SetShoppingCartBookModel} obj Optional instance to populate.
     * @return {module:model/SetShoppingCartBookModel} The populated <code>SetShoppingCartBookModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SetShoppingCartBookModel();

            if (data.hasOwnProperty('annual')) {
                obj['annual'] = ApiClient.convertToType(data['annual'], 'String');
            }
            if (data.hasOwnProperty('bookIsbn')) {
                obj['bookIsbn'] = ApiClient.convertToType(data['bookIsbn'], 'String');
            }
            if (data.hasOwnProperty('bookListId')) {
                obj['bookListId'] = ApiClient.convertToType(data['bookListId'], 'Number');
            }
            if (data.hasOwnProperty('isChecked')) {
                obj['isChecked'] = ApiClient.convertToType(data['isChecked'], 'Boolean');
            }
            if (data.hasOwnProperty('quantity')) {
                obj['quantity'] = ApiClient.convertToType(data['quantity'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * annual
 * @member {String} annual
 */
SetShoppingCartBookModel.prototype['annual'] = undefined;

/**
 * Book Isbn
 * @member {String} bookIsbn
 */
SetShoppingCartBookModel.prototype['bookIsbn'] = undefined;

/**
 * Book List Id
 * @member {Number} bookListId
 */
SetShoppingCartBookModel.prototype['bookListId'] = undefined;

/**
 * is check
 * @member {Boolean} isChecked
 */
SetShoppingCartBookModel.prototype['isChecked'] = undefined;

/**
 * quantity
 * @member {Number} quantity
 */
SetShoppingCartBookModel.prototype['quantity'] = undefined;






export default SetShoppingCartBookModel;

